<script setup lang="ts">
import { getExpRankApi } from "@/api/pvp-card";
import { onMounted, ref } from "vue";
import type { PvpCardGameProfile } from "@/api/pvp-card/type";
import { getLevel } from "awakening-of-war-shared";
import { formatNumberWithWan } from "@/utils";

const list = ref<PvpCardGameProfile[]>([]);

const total = ref(0)
const params = ref({ page: 1, pageSize: 100 })

async function refreshData() {
  const res = await getExpRankApi(params.value);
  list.value = res.records
  total.value = res.total

}
onMounted(() => {
  refreshData()
})
defineExpose({
  refreshData
})

</script>
<template>
  <div class="">
    <el-table :data="list" border :style="{ width: '100%', height: '40vh' }" size="small">
      <el-table-column prop="rank" label="排名" width="50">
        <template #default="{ $index }">
          {{ ((params.page - 1) * params.pageSize) + $index + 1 }}
        </template>
      </el-table-column>
      <el-table-column prop="nickname" label="昵称">
        <template #default="{ row }">
          <span class="level">lv{{ getLevel(row.exp) }}</span>
          <span class="nickname" :style="{ background: row.nickNameColor }">{{
            row.nickName }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="exp" label="经验" width="100">
        <template #default="{ row }">
          <span>{{ formatNumberWithWan(row.exp) }}</span>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination :pager-count="5" style="flex:1;" :page-size="params.pageSize" v-model:current-page="params.page"
      size="small" layout="prev, pager, next" :total="total" @change="refreshData" />
  </div>
</template>
<style lang="scss" scoped>
.level {
  display: inline-block;
  width: 30px;
}
</style>